module.exports = __webpack_public_path__ + "img/Vapaus-logo.b546b5d2.svg";